import { Component, OnDestroy, OnInit, ViewChild, Inject, afterNextRender } from '@angular/core';
import { MatTable, MatTableDataSource, MatTableModule } from "@angular/material/table";
import { Router } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { Subscription } from "rxjs";
import { MatSortModule } from "@angular/material/sort";
import { SortEvent, UserRow } from 'allai-admin-shared';
import { UsersControls } from './user-controls/users-controls.component.js';
import { UsersService } from '../../services/users/user.service.js';
import { UsersFilterService } from '../../services/users/user-filter.service.js';

/** The organization list page */
@Component({
	selector: 'app-organizations',
	imports: [
		MatTableModule,
		MatIconModule,
		MatButtonModule,
		UsersControls,
		MatSortModule
	],
	templateUrl: './users.component.html',
	styleUrl: './users.component.scss'
})
export class UsersComponent implements OnInit, OnDestroy {

	/** Columns in the table */
	readonly displayedColumns: (keyof UserRow)[] = ['id', 'first_name', 'last_name', 'email', 'enabled', 'user_type', 'id_organization', 'organization_name', 'signature', 'appointment_description'];

	/** Data source for the table */
	dataSource: MatTableDataSource<UserRow>;

	/** Current search filter being applied */
	private _searchFilter: string;

	/** Table on the page showing the user */
	@ViewChild(MatTable)
	private table: MatTable<UserRow>;

	/** Subscription for new organizations being loaded from filters */
	private newOrganizationsSub: Subscription;

	@ViewChild(UsersControls)
	private usersControls: UsersControls;

	constructor(private userService: UsersService,
		private userFilterService: UsersFilterService,
		private router: Router,
		@Inject(ViewportScroller) private viewportScroller: ViewportScroller) {
	}

	ngOnInit() {
		this.newOrganizationsSub = this.userService.onNewUsers.subscribe(() => {
			this.refresh();
		});

		this.userService.resolveUsers();

	}

	private refresh() {

		const userList = this.userService.userList;

		this.usersControls.setTotal(this.userService.total);

		const rows: UserRow[] = userList;

		//make sure to re-render table
		this.dataSource = new MatTableDataSource<UserRow>(rows);
		this.table?.renderRows();
	}

	ngOnDestroy() {
		this.newOrganizationsSub?.unsubscribe();
	}

	/** Open an organization that was clicked on */
	goto(row: UserRow) {
		let url = this.router.serializeUrl(this.router.createUrlTree(['/', 'users', row.id]));
		window.open(url, `_user_${row.id}`);
	}

	formatDate(date: string): string {
		return new Date(date).toLocaleString();
	}

	sortData(sortEvent: SortEvent) {
		this.userFilterService.sortOrder = sortEvent
	}
}
